import { createApp } from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'
import { Router } from 'vue-router'

import App from '@/App.vue'
import { growthbookInstance } from '@/utils/growthbook'
import { initializeGtm } from '@/utils/gtm'
import { mixPanelInstance } from '@/utils/mixPanel'
import createRouter from '@/wave.router'

import { fetchConfig } from './config/fetch'
import './style.css'

// First load the config
const config = await fetchConfig()
// Create the router
const router: Router = createRouter(config)

const app = createApp(App)
app.use(config)
app.use(router)
app.use(initializeGtm(config, router))

// Create GrowthbookClient to use default values
const growthbook = await growthbookInstance.createDefaultGrowthbookClient({
  clientKey: config.GROWTHBOOK.clientKey,
  enableDevMode: false,
})
app.use(growthbook)

const mixPanel = await mixPanelInstance.createMixPanelClient(config.MIXPANEL?.token)
app.use(mixPanel)

app.use(VueObserveVisibility)

app.mount('#app')
